import { ArrowDownCircle, ArrowUpCircle, SlidersHorizontal } from 'lucide-react';
import EmptyState from '../../components/EmptyState';
import { formatQty } from '../../utils/soldBy';
import styles from './Inventory.module.css';

const TYPE_META = {
  IN: { icon: ArrowUpCircle, label: 'Stock in', cls: 'moveIn' },
  OUT: { icon: ArrowDownCircle, label: 'Stock out', cls: 'moveOut' },
  ADJUST: { icon: SlidersHorizontal, label: 'Adjusted', cls: 'moveAdjust' },
};

export default function MovementHistoryPanel({ movements }) {
  if (movements.length === 0) {
    return <EmptyState title="No movements yet" description="Stock changes will show up here." />;
  }

  return (
    <div className={styles.historyList}>
      {movements.map((m) => {
        const meta = TYPE_META[m.type];
        const Icon = meta.icon;
        return (
          <div key={m.id} className={styles.historyRow}>
            <span className={`${styles.historyIcon} ${styles[meta.cls]}`}>
              <Icon size={15} />
            </span>
            <div className={styles.historyInfo}>
              <p className={styles.historyProduct}>{m.productName}</p>
              <p className={styles.historyReason}>{m.reason} · {m.user}</p>
            </div>
            <div className={styles.historyRight}>
              <span className={`${styles.historyQty} ${styles[meta.cls]}`}>
                {m.type === 'OUT' ? '-' : m.type === 'ADJUST' && m.qty > 0 ? '+' : m.type === 'IN' ? '+' : ''}
                {formatQty(Math.abs(m.qty), m)}
              </span>
              <span className={styles.historyDate}>{new Date(m.date).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
